import _classCallCheck from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { pluck, pluckNumber, getColumnColor, getPointColor, getFirstAlpha, toRaphaelColor, extend2 } from '../../../fc-core/src/lib';
import pointColor from '../../../fc-core/src/print-color';
import { priorityList } from '../../../fc-core/src/schedular';

var UNDEF,
    hm,
    hexcode = /^#?[0-9a-f]{6}/i,
    BLANKSTRING = '',
    COLOR_BLACK = '000000',
    whiteHex = /FFFFFF/i,
    whiteRgb = /255,255,255/,
    rgbaToHex = function rgbaToHex(a) {
  return a = a.replace('rgba(', '').split(','), '#' + (COLOR_BLACK + (a[0] << 16 | a[1] << 8 | a[2]).toString(16)).slice(-6);
},
    reduceAlpha = function reduceAlpha(a, b) {
  var c,
      d,
      e = [];
  if ('number' == typeof a) return b;

  for (d = a.split && a.split(','), c = 0; c < d.length; c++) {
    e.push(b);
  }

  return e.join();
},
    getAlpha = function getAlpha(a) {
  var b;
  return /rgb/.test(a) ? (b = a.match(/[\d\.]+\)/g), parseFloat(b && b[0])) : a.FCcolor ? getFirstAlpha(a.FCcolor.alpha) : void 0;
},
    removeHighlightStateCosmetics = function removeHighlightStateCosmetics(a) {
  a.forEach(function (a) {
    a.removeStateCosmetics('highlight');
  });
},
    setDataLabelAttrs = function setDataLabelAttrs(a, b, c, d, e) {
  var f, g, h, i, j, k, l, m, n, o;
  f = rgbaToHex(d.color), h = 100 * getAlpha(d.color), g = e ? pluck(c.valuefontcolor, f) : f, i = e ? pluck(c.valuefontalpha, c.alpha, h) : h, f = d.backgroundColor === BLANKSTRING ? BLANKSTRING : rgbaToHex(d.backgroundColor), h = d.backgroundColor === BLANKSTRING ? 0 : 100 * getAlpha(d.backgroundColor), isNaN(h) && (h = 0), k = e ? pluck(c.valuebgcolor, f) : f, j = e ? pluck(c.valuebgalpha, c.alpha, h) : h, n = toRaphaelColor({
    color: k,
    alpha: j
  }), f = d.borderColor === BLANKSTRING ? BLANKSTRING : rgbaToHex(d.borderColor), h = d.borderColor === BLANKSTRING ? BLANKSTRING : 100 * getAlpha(d.borderColor), isNaN(h) && (h = 0), l = e ? pluck(c.valuebordercolor, f) : f, m = e ? pluck(c.valueborderalpha, c.alpha, h) : h, o = toRaphaelColor({
    color: l,
    alpha: m
  }), b && a.setAnimation({
    el: b,
    label: 'highlightedDataLabel',
    attr: {
      fill: toRaphaelColor({
        color: g,
        alpha: i
      }),
      "text-bound": [n, o, d.borderThickness, d.borderPadding, d.borderRadius, d.borderDash]
    }
  });
},
    parseConfStr = function parseConfStr(a) {
  var b,
      c,
      d,
      e,
      f,
      g = a.split(','),
      h = {};

  for (b = 0, c = g.length; b < c; b++) {
    d = g[b].split('='), e = d[0], f = d[1], h[e] = f;
  }

  return h;
},
    getColor = function getColor(a, b) {
  var c,
      d,
      e = {};

  for (c in a) {
    'alpha' === c ? e[c] = b.alpha ? reduceAlpha(a[c], b.alpha) : a[c] : 'color' === c ? (-1 !== a[c].indexOf(',') && b.color && (d = b.color + ',' + a[c].substring(a[c].indexOf(',') + 1)), e[c] = pluck(d || b.color, a[c])) : e[c] = a[c];
  }

  return e;
},
    parseColor = function parseColor(a, b, c) {
  var d,
      e,
      f = b.color;
  return /rgb/.test(a) ? (d = pluck(b.alpha, 100 * getAlpha(a)), /rgb/.test(f) && (f = rgbaToHex(f)), e = c ? toRaphaelColor({
    color: pluck(f, rgbaToHex(a)),
    alpha: d
  }) : a) : a.FCcolor ? e = c ? toRaphaelColor(getColor(a.FCcolor, b)) : toRaphaelColor(a.FCcolor) : hexcode.test(a.color || a) && (e = c ? toRaphaelColor({
    color: pluck(b.color, a.color, a),
    alpha: pluck(b.alpha, a.alpha)
  }) : toRaphaelColor({
    color: a.color || a,
    alpha: a.alpha
  })), e;
},
    setBoxAndWhiskerAttrs = function setBoxAndWhiskerAttrs(a, b, c, d, e, f) {
  var g,
      h,
      i,
      j,
      k,
      l,
      m,
      n,
      o = {},
      p = {};
  e ? (g = getColumnColor(d.color || c.upperColorArr[0].FCcolor.color, d.alpha.toString(), c.upperColorArr[0].FCcolor.ratio, c.upperColorArr[0].FCcolor.angle, f, d.bordercolor || rgbaToHex(c.upperBoxBorder.color), d.borderalpha && d.borderalpha.toString() || (100 * getAlpha(c.lowerBoxBorder.color)).toString()), p = toRaphaelColor(g[0]), h = getColumnColor(d.color || c.lowerColorArr[0].FCcolor.color, d.alpha.toString(), c.lowerColorArr[0].FCcolor.ratio, c.lowerColorArr[0].FCcolor.angle, f, d.bordercolor || rgbaToHex(c.lowerBoxBorder.color), d.borderalpha && d.borderalpha.toString() || (100 * getAlpha(c.lowerBoxBorder.color)).toString()), o = toRaphaelColor(h[0]), i = parseColor(c.median.color, d, e), l = parseColor(c.lowerQuartile.color, d, e), m = parseColor(c.upperQuartile.color, d, e)) : (p = toRaphaelColor(c.upperColorArr[0]), o = toRaphaelColor(c.lowerColorArr[0]), i = c.median.color, j = c.upperBoxBorder.color, k = c.lowerBoxBorder.color, m = c.upperQuartile.color, l = c.lowerQuartile.color), n = b.upperBoxElem, a.setAnimation({
    el: n,
    label: 'highlightedBoxAnsWhiskerPlot',
    attr: {
      fill: p,
      "drop-shadow": n.attrs['drop-shadow'] && 'none' !== n.attrs['drop-shadow'] ? [1, 1, 3, 'rgba(64,64,64,' + getAlpha(p) + ')', n.attrs[4], n.attrs['drop-shadow'][5]] : 'none'
    }
  }), n = b.lowerBoxElem, a.setAnimation({
    el: n,
    label: 'highlightedBoxAnsWhiskerPlot',
    attr: {
      fill: o,
      "drop-shadow": n.attrs['drop-shadow'] && 'none' !== n.attrs['drop-shadow'] ? [1, 1, 3, 'rgba(64,64,64,' + getAlpha(o) + ')', n.attrs[4], n.attrs['drop-shadow'][5]] : 'none'
    }
  }), n = b.lowerBoxBorderEle, a.setAnimation({
    el: n,
    label: 'highlightedBoxAnsWhiskerPlot',
    attr: {
      stroke: k
    }
  }), b.upperBoxBorderEle && a.setAnimation({
    el: b.upperBoxBorderEle,
    label: 'highlightedBoxAnsWhiskerPlot',
    attr: {
      stroke: j
    }
  }), b.lowerQuartileEle && a.setAnimation({
    el: b.lowerQuartileEle,
    label: 'highlightedBoxAnsWhiskerPlot',
    attr: {
      stroke: l
    }
  }), b.upperQuartileEl && a.setAnimation({
    el: b.upperQuartileEl,
    label: 'highlightedBoxAnsWhiskerPlot',
    attr: {
      stroke: m
    }
  }), b.midLineElem && a.setAnimation({
    el: b.midLineElem,
    label: 'highlightedBoxAnsWhiskerPlot',
    attr: {
      stroke: i
    }
  });
},
    setDataObjectAttrs = function setDataObjectAttrs(a, b, c) {
  var d,
      e,
      f,
      g,
      h,
      i,
      k,
      l,
      m,
      n,
      o = a.getFromEnv('chart'),
      p = a.getFromEnv('animationManager'),
      q = o.config,
      r = o.config.dataLabelStyle,
      s = a.components.data;

  for (d = 0, e = s.length; d < e; d++) {
    if (k = s[d], !!k) for (i in f = k.graphics, q = k.config, g = q.anchorProps, n = g.enabled, h = {
      fillColor: {
        FCcolor: {
          alpha: c && n ? pluck(b.anchorbgalpha, b.alpha, g.bgAlpha) : g.bgAlpha,
          color: c && n ? pluck(b.anchorbgcolor, b.color, g.bgColor) : g.bgColor
        }
      },
      borderColor: {
        FCcolor: {
          alpha: c && n ? pluck(b.borderalpha, b.alpha, g.borderAlpha) : g.borderAlpha,
          color: c && n ? pluck(b.anchorbordercolor, b.color, g.borderColor) : g.borderColor
        }
      },
      imageAlpha: c ? b.alpha : g.imageAlpha,
      imageScale: g.imageScale
    }, f) {
      l = !i.match(/error/ig) && f[i], m = l && l.type, 'path' === m ? p.setAnimation({
        el: l,
        label: 'highlightedAnchorPlot',
        attr: {
          fill: toRaphaelColor(h.fillColor),
          stroke: toRaphaelColor(h.borderColor)
        }
      }) : 'image' === m ? p.setAnimation({
        el: l,
        label: 'highlightedAnchorImagePlot',
        attr: {
          opacity: h.imageAlpha / 100
        }
      }) : 'text' === m ? setDataLabelAttrs(p, l, b, r, c) : void 0;
    }
  }
},
    setLegendAttrs = function setLegendAttrs(a, b, c, d, e) {
  var f,
      g = a.getStateCosmetics('default').symbol || {},
      h = g.fill,
      i = g.stroke,
      j = e ? pluck(d.color, rgbaToHex(c.text.fill)) : rgbaToHex(c.text.fill),
      k = b.legendItemLine,
      l = c.symbol.stroke,
      m = a.getFromEnv('animationManager');
  k && l && (hexcode.test(l) ? m.setAnimation({
    el: k,
    label: 'highlightedLegendItem',
    attr: {
      stroke: e ? toRaphaelColor({
        color: pluck(d.color, l),
        alpha: d.alpha
      }) : l
    }
  }) : (f = parseColor(l, d, e), m.setAnimation({
    el: k,
    label: 'highlightedLegendItem',
    attr: {
      stroke: f
    }
  }))), h && (h.match(hexcode) ? h = e && !whiteHex.test(h) ? toRaphaelColor({
    color: d.color || h,
    alpha: d.alpha
  }) : h : h = whiteRgb.test(h) ? h : parseColor(h, d, e)), i && (hexcode.test(i) ? i = e && !whiteHex.test(i) ? toRaphaelColor({
    color: d.color || i,
    alpha: d.alpha
  }) : i : i = e && !whiteRgb.test(i) ? d.color ? toRaphaelColor({
    color: d.color,
    alpha: d.alpha
  }) : i : i), a.setStateCosmetics('highlight', {
    symbol: {
      fill: h || 'none',
      stroke: i || 'none',
      opacity: (e ? d.alpha : 100) / 100
    },
    text: {
      fill: toRaphaelColor({
        color: j,
        alpha: e ? d.alpha : 100
      })
    }
  }), a.hasState('hidden') || a.setLegendState('highlight', !0);
},
    getLegendGraphics = function getLegendGraphics(a, b) {
  var c = a.getFromEnv('legend'),
      d = c.getItem(b);
  return d && d.getGraphicalElement();
},
    fadeout = {
  area: function area(a, b, c) {
    var d,
        e,
        f,
        g,
        h,
        j,
        k,
        l,
        m,
        n,
        o,
        p,
        q,
        r,
        s,
        t = this,
        u = t.getFromEnv('chart'),
        v = t.getFromEnv('animationManager'),
        w = u.config,
        x = u.getFromEnv('legend'),
        y = x.getChildren('legendItem') || [],
        z = arguments[4],
        A = y.length,
        B = parseConfStr(a),
        C = getLegendGraphics(u, z),
        D = w.dataLabelStyle,
        E = t.getContainer('labelGroup'),
        F = t.config,
        G = F.shadow || {},
        H = 0 < G.opacity;

    if (!c && t.getState('visible')) {
      for (B.alpha = B.alpha || 30, e = 0; e < A && (d = y[e] || {}, d.getId() !== z); e++) {
        ;
      }

      E && v.setAnimation({
        el: E,
        label: 'highlightedGroup',
        attr: {
          opacity: b ? B.alpha / 100 : getAlpha(D.color)
        }
      }), g = F.plotbordercolor, m = F.plotborderalpha, r = F.plotfillalpha, f = F.plotgradientcolor, p = t.getGraphicalElement('lineElement') || t.getGraphicalElement('splineElement'), k = b ? pluck(B.bordercolor, B.color, g) : g, B.color && (n = B.color + (f ? ',' + f : BLANKSTRING)), o = F.fillColor.color, h = b ? pluck(n, o) : o, q = F.plotfillangle, j = b ? B.alpha : r, l = b ? pluck(B.borderalpha, B.alpha) : m, s = !!H && (b ? B.alpha / 100 : j / 100), v.setAnimation({
        el: p,
        label: 'highlightedAreaPlot',
        attr: {
          fill: toRaphaelColor({
            color: h,
            alpha: j,
            angle: q
          }),
          stroke: toRaphaelColor({
            color: k,
            alpha: l
          })
        }
      }), p.shadow(s), C && setLegendAttrs(d, C, d.parseLegendCosmetics(), B, b), setDataObjectAttrs(t, B, b);
    }
  },
  bubble: function bubble(a, b, c) {
    var d,
        e,
        f,
        g,
        h,
        j,
        k,
        l,
        m,
        n,
        o,
        p,
        q = this,
        r = q.getFromEnv('chart'),
        s = q.getFromEnv('animationManager'),
        t = r.config,
        u = r.getFromEnv('legend'),
        v = u.getChildren('legendItem') || [],
        w = v.length,
        x = arguments[4],
        y = t.dataLabelStyle,
        z = getLegendGraphics(r, x),
        A = q.getContainer('labelGroup'),
        B = parseConfStr(a);

    if (!1 === c && q.getState('visible')) {
      for (B.alpha || (B.alpha = 30), f = q.components.data || [], e = 0; e < w && (d = v[e] || {}, d.getId() !== x); e++) {
        ;
      }

      for (setLegendAttrs(d, z, d.parseLegendCosmetics(), B, b), A && s.setAnimation({
        el: A,
        label: 'highlightedGroup',
        attr: {
          opacity: b ? B.alpha / 100 : getAlpha(y.color)
        }
      }), (e = 0, w = f.length); e < w; e++) {
        (g = f[e], !!g) && (o = g.graphics, h = g.config, j = h.colorObj, l = h.is3D, k = o.element, p = o.label, l ? (n = b ? getPointColor(pluck(B.color, j.FCcolor.color), pluck(B.alpha, getFirstAlpha(j.alpha))) : j, n = toRaphaelColor(n)) : (n = b ? pluck(B.color, j.color) : j.color, m = b ? B.alpha : j.alpha, n = toRaphaelColor({
          color: n,
          alpha: m
        })), k && s.setAnimation({
          el: k,
          label: 'highlightedBubblePlot',
          attr: {
            fill: n
          }
        }), p && setDataLabelAttrs(s, p, B, y, b));
      }
    }
  },
  pie: function pie(a, b, c, d) {
    var e,
        f,
        g,
        h,
        j,
        k,
        l,
        m,
        n,
        o,
        p,
        q,
        r,
        s,
        t,
        u,
        v,
        w,
        x = this,
        y = d.getFromEnv('chart'),
        z = d.getFromEnv('animationManager'),
        A = y.getFromEnv('legend'),
        B = this,
        C = {},
        D = arguments[4],
        E = A.getChildren('legendItem') || [],
        F = parseConfStr(a);

    if (!1 === c) {
      for (F.alpha || (F.alpha = 30), f = x.graphics.element, g = x.config, (s = 0, r = E.length); s < r && (v = E[s], u = v.getId(), u !== D); s++) {
        ;
      }

      t = getLegendGraphics(y, D), setLegendAttrs(v, t, v.parseLegendCosmetics(), F, b), j = g.color.color, B = f.data('plotItem'), y = B.chart, e = B.style, h = 90, o = y.config.is3D, m = B.center, m && (k = m[0], l = m[1], n = B.radius, C = {
        cx: k,
        cy: l,
        r: n
      }), j = b ? pointColor(pluck(F.color, j), F.alpha, h) : g.color, w = b ? F.alpha : j.alpha, j = extend2(j, C), o ? f && z.setAnimation({
        el: f,
        label: 'highlightedPiePlot',
        attr: {
          color: j.color.split(',')[0],
          alpha: w
        }
      }) : f && z.setAnimation({
        el: f,
        label: 'highlightedPiePlot',
        attr: {
          fill: toRaphaelColor(j)
        }
      }), p = x.graphics.label, q = x.graphics.connector, p && setDataLabelAttrs(z, p, F, e, b), q && z.setAnimation({
        el: q,
        label: 'highlightedPieConnectorPlot',
        attr: {
          opacity: b ? F.alpha / 100 : getAlpha(e.color)
        }
      });
    }
  },
  line: function line(a, b, c) {
    var d,
        e,
        f,
        g,
        h,
        j,
        k,
        l = this,
        m = l.getFromEnv('chart'),
        n = l.getFromEnv('animationManager'),
        o = m.config,
        p = m.getFromEnv('legend'),
        q = p.getChildren('legendItem') || [],
        r = q.length,
        s = arguments[4],
        t = o.dataLabelStyle,
        u = parseConfStr(a),
        v = getLegendGraphics(m, s),
        w = l.getContainer('labelGroup'),
        x = l.getContainer('errorPlotGroup'),
        y = l.config,
        z = y.linecolor,
        A = y.alpha || y.lineAlpha,
        B = y.shadow || {},
        C = 0 < B.opacity,
        D = l.config.lineOb,
        E = '';

    if (!c && l.getState('visible')) {
      for (u.alpha || (u.alpha = 30), h = 0; h < r && (d = q[h] || {}, d.getId() !== s); h++) {
        ;
      }

      if (x && (e = y.errorBarColor && getAlpha(y.errorBarColor), f = b ? pluck(u.alpha / 100, e) : e, n.setAnimation({
        el: x,
        label: 'highlightedGroup',
        attr: {
          opacity: f
        }
      })), w && n.setAnimation({
        el: w,
        label: 'highlightedGroup',
        attr: {
          opacity: b ? u.alpha / 100 : getAlpha(t.color)
        }
      }), g = l.getGraphicalElement('lineElement'), z = b ? pluck(u.color, z) : z, A = b ? pluck(u.alpha, A) : A, j = !!C && (b ? u.alpha / 100 : A / 100), g && n.setAnimation({
        el: g,
        label: 'highlightedLinePlot',
        attr: {
          stroke: toRaphaelColor({
            color: z,
            alpha: A
          })
        }
      }), g && g.shadow(j), 'object' == typeof D && D) for (E in D) {
        k = D[E] && D[E].el, k && n.setAnimation({
          el: k,
          label: 'highlightedLinePlot',
          attr: {
            stroke: b ? z : D[E].attr.stroke,
            "stroke-opacity": A / 100
          }
        }), k && k.shadow(j);
      }
      v && setLegendAttrs(d, v, d.parseLegendCosmetics(), u, b), setDataObjectAttrs(l, u, b);
    }
  },
  boxandwhisker2d: function boxandwhisker2d(a, b, c) {
    var d,
        e,
        f,
        g,
        h,
        j,
        k = this,
        l = k.config,
        m = k.getFromEnv('chart'),
        n = k.getFromEnv('animationManager'),
        o = l.isRoundEdges,
        p = arguments[4],
        q = getLegendGraphics(m, p),
        r = k.getContainer('lowerWhiskerGroup'),
        s = k.getContainer('upperWhiskerGroup'),
        t = k.getContainer('labelGroup'),
        u = m.getFromEnv('legend'),
        v = u.getChildren('legendItem') || [],
        w = v.length,
        x = parseConfStr(a);

    if (!1 === c && k.getState('visible')) {
      for (x.alpha || (x.alpha = 30), d = 0; d < w && (e = v[d] || {}, e.getId() !== p); d++) {
        ;
      }

      for (setLegendAttrs(e, q, e.parseLegendCosmetics(), x, b), r && n.setAnimation({
        el: r,
        label: 'highlightedGroup',
        attr: {
          opacity: b ? x.alpha / 100 : 1
        }
      }), s && n.setAnimation({
        el: s,
        label: 'highlightedGroup',
        attr: {
          opacity: b ? x.alpha / 100 : 1
        }
      }), t && n.setAnimation({
        el: t,
        label: 'highlightedGroup',
        attr: {
          opacity: b ? x.alpha / 100 : 1
        }
      }), j = k.components.data, (d = 0, w = j.length); d < w; d++) {
        g = j[d], h = g.config, f = g.graphics, setBoxAndWhiskerAttrs(n, f, h, x, b, o);
      }
    }
  },
  heatmap: function heatmap(a, b, c, d) {
    var e,
        f,
        g,
        h,
        j,
        k,
        l,
        m,
        n,
        o,
        p,
        q,
        r = this,
        s = d.getFromEnv('chart'),
        t = d.getFromEnv('animationManager'),
        u = s.config,
        v = u.dataLabelStyle,
        w = s.getFromEnv('legend'),
        x = arguments[4],
        y = parseConfStr(a),
        z = w.getChildren('legendItem') || [];

    if (!c && d.getState('visible') && !1 !== r.visible) {
      for (y.alpha || (y.alpha = b ? 30 : 100), u = r.config, (n = 0, m = z.length); n < m && (q = z[n], p = q.getId(), p !== x); n++) {
        ;
      }

      for (k in o = getLegendGraphics(s, x), setLegendAttrs(q, o, q.parseLegendCosmetics(), y, b), j = rgbaToHex(u.color), h = getAlpha(u.color), e = b ? pluck(y.color, j) : j, f = b ? y.alpha : 100 * h, l = r.graphics, g = l.element, g && t.setAnimation({
        el: g,
        label: 'highlightedHeatmapPlot',
        attr: {
          fill: toRaphaelColor({
            color: e,
            alpha: f
          })
        }
      }), l) {
        g = l[k], 'text' === g.type && setDataLabelAttrs(t, g, y, v, b);
      }
    }
  },
  funnelpyramid: function funnelpyramid(a, b, c, d) {
    var e,
        f,
        g,
        h,
        j,
        k,
        l,
        m,
        n,
        o,
        p,
        q,
        r,
        s,
        t,
        u,
        v = this,
        w = d.getFromEnv('chart'),
        x = d.getFromEnv('animationManager'),
        y = w.getFromEnv('legend'),
        z = parseConfStr(a),
        A = y.getChildren('legendItem') || [],
        B = arguments[4];

    if (!1 === c) {
      for (z.alpha || (z.alpha = 30), h = v, (r = 0, q = A.length); r < q && (u = A[r], t = u.getId(), t !== B); r++) {
        ;
      }

      s = getLegendGraphics(w, B), setLegendAttrs(u, s, u.parseLegendCosmetics(), z, b), f = h.style, p = h.color, j = rgbaToHex(p), o = getAlpha(p), k = b ? pluck(z.color, j) : j, l = b ? z.alpha : 100 * o, g = v.getGraphicalElement('graphic'), m = v.getGraphicalElement('dataLabel'), n = v.getGraphicalElement('connector'), e = v.style, g && x.setAnimation({
        el: g,
        label: 'highlightedFunnelPyramidPlot',
        attr: {
          fill: toRaphaelColor({
            color: k,
            alpha: l
          })
        }
      }), m && setDataLabelAttrs(x, m, z, e, b), n && x.setAnimation({
        el: n,
        label: 'highlightedFunnelPyramidConnectorPlot',
        attr: {
          opacity: b ? z.alpha / 100 : getAlpha(f.color)
        }
      });
    }
  },
  default: function _default(a, b, c) {
    var d,
        e,
        f,
        g,
        h,
        j,
        k,
        l,
        m,
        n,
        o,
        p,
        q,
        r,
        s,
        t = this,
        u = t.config,
        v = t.getFromEnv('chart'),
        w = t.getFromEnv('animationManager'),
        x = v.config,
        y = x.dataLabelStyle,
        z = x.useroundedges,
        A = v.config.is3D,
        B = parseConfStr(a),
        C = arguments[4],
        D = getLegendGraphics(v, C),
        E = t.getContainer('labelGroup'),
        F = t.getContainer('errorPlotGroup'),
        G = '',
        H = v.getFromEnv('legend'),
        I = H.getChildren('legendItem') || [],
        J = I.length,
        K = u.showShadow;

    if (!1 === c && !0 === t.getState('visible')) {
      for (B.alpha || (B.alpha = '30'), o = t.components.data || [], e = 0; e < J && (r = I[e] || {}, r.getId() !== C); e++) {
        ;
      }

      for (D && setLegendAttrs(r, D, r.parseLegendCosmetics(), B, b), E && w.setAnimation({
        el: E,
        label: 'highlightedGroup',
        attr: {
          opacity: b ? B.alpha / 100 : getAlpha(y.color)
        }
      }), F && (h = u.errorBarColor && getAlpha(u.errorBarColor), j = b ? pluck(B.alpha / 100, h) : h, w.setAnimation({
        el: F,
        label: 'highlightedGroup',
        attr: {
          opacity: j
        }
      })), (e = 0, J = o.length); e < J; e++) {
        (p = o[e], p && p.graphics) && (x = p.config, n = x.colorArr[0], f = x.colorArr[1], s = f.FCcolor.alpha, d = n.FCcolor.color, G = -1 !== (l = d.indexOf(',')) && B.color ? B.color + d.substring(l) : pluck(B.color, d), m = A ? s : pluck(B.borderalpha, B.alpha, s), 0 === pluckNumber(s) && (m = '0'), k = b ? getColumnColor(G, B.alpha, n.FCcolor.ratio, n.FCcolor.angle, z, pluck(B.bordercolor, f.FCcolor.color), m, !1, A) : [n, f], g = p.graphics.element, g && (d = toRaphaelColor(k[0]), f = toRaphaelColor(k[1]), w.setAnimation({
          el: g,
          label: 'highlightedDefaultPlot',
          attr: {
            stroke: f,
            fill: d
          }
        }), g.shadow({
          opacity: K ? getFirstAlpha(k[0].alpha) / 100 : 0
        })), q = p.graphics.label, setDataLabelAttrs(w, q, B, y, b));
      }
    }
  }
},
    highlighteffect = function highlighteffect(a) {
  a && hm.add(a);
};

function FCPlugger(a) {
  hm = new (
  /*#__PURE__*/
  function () {
    function _class() {
      _classCallCheck(this, _class);

      this.effectStore = {}, this.eventHandlers = {};
    }

    _createClass(_class, [{
      key: "add",
      value: function add(a) {
        this.effectStore[a.name] = a;
      }
    }, {
      key: "attachEventHandlers",
      value: function attachEventHandlers(b, c) {
        var d = this,
            e = d.eventHandlers,
            f = e[b];
        f || (this.eventHandlers[b] = {}, this.eventHandlers[b].listenerFn = a.addEventListener(b, c));
      }
    }, {
      key: "applyEffect",
      value: function applyEffect(a, b, c) {
        var d,
            e,
            f,
            g,
            h,
            j,
            k,
            l,
            m,
            n,
            o,
            p,
            q,
            r = this.effectStore,
            s = a.getFromEnv('chart-attrib'),
            t = a.config.defaultDatasetType,
            u = s.plothighlighteffect && s.plothighlighteffect.toLowerCase(),
            v = a.getDatasets(),
            w = a.config.isSingleSeries ? v[0].components.data : v,
            x = pluck(b.itemId, b.legendItemId, b.legendItemIndex),
            y = '';
        if (removeHighlightStateCosmetics(a.getFromEnv('legend').getChildren('legendItem')), ('funnel' === a.getName() || 'Pyramid' === a.getName()) && (w = v[0].getChildren('data')), a.getFromEnv('animationManager').setAnimationState('plotHighlighter'), u && (u = u.replace(/\s+/g, '').split('|'), q = u[0], y = u[1] || ''), q && r[q]) if ('HeatMap' === a.getName()) for (d = a.getFromEnv('colorRange'), l = a.getFromEnv('legend'), e = l.getItem(x), p = function p(a) {
          var b,
              c,
              d = l.getChildren('legendItem'),
              e = d && d.length;

          for (b = 0; b < e; ++b) {
            if (d[b].config.datasetObj.code === a) {
              c = d[b].getId();
              break;
            }
          }

          return c;
        }, n = e.config.datasetObj, j = 0; j < w.length; j++) {
          h = w[j], f = h.config.value, o = d.getColorObj(f), o.outOfRange || (n.code === o.code ? r[q][t].call(h, y, c, !0, v[0], x) : r[q][t].call(h, y, c, !1, v[0], p(o.code)));
        } else for (j = 0, m = w.length; j < m; j++) {
          h = w[j], t = h.getName && h.getName() || t, t = t.toLowerCase(), g = pluck(h.config.itemId, h.config.legendItemId), g !== UNDEF && (k = g === x, r[q][t] ? r[q][t].call(h, y, c, k, v[0], g) : r[q]['default'].call(h, y, c, k, v[0], g));
        }
      }
    }]);

    return _class;
  }())(), hm.attachEventHandlers('legenditemrollover', function (a, b) {
    var c = a.sender.apiInstance;
    !1 !== c.hasInteractiveLegend && !1 !== c.highlightEnabled && hm.applyEffect(c, b, !0);
  }), hm.attachEventHandlers('legenditemrollout', function (a, b) {
    var c = a.sender.apiInstance;
    !1 !== c.hasInteractiveLegend && !1 !== c.highlightEnabled && hm.applyEffect(c, b, !1);
  }), hm.attachEventHandlers('legenditemclicked', function (a, b) {
    var c = a.sender.apiInstance;
    c.addJob('plothighlighteffect', function () {
      !1 !== c.hasInteractiveLegend && !1 !== c.highlightEnabled && hm.applyEffect(c, b, !0);
    }, priorityList.postRender);
  }), highlighteffect({
    name: 'fadeout',
    area: fadeout.area,
    radar: fadeout.area,
    bubble: fadeout.bubble,
    pie2d: fadeout.pie,
    line: fadeout.line,
    spline: fadeout.line,
    splinearea: fadeout.area,
    pie3d: fadeout.pie,
    zoomline: fadeout.line,
    funnelpoint: fadeout.funnelpyramid,
    pyramidpoint: fadeout.funnelpyramid,
    scatter: fadeout.line,
    selectscatter: fadeout.line,
    dragline: fadeout.line,
    dragarea: fadeout.area,
    realtimearea: fadeout.area,
    realtimeline: fadeout.line,
    realtimelinedy: fadeout.line,
    realtimestackedarea: fadeout.area,
    errorline: fadeout.line,
    errorscatter: fadeout.line,
    stepline: fadeout.line,
    doughnut2d: fadeout.pie,
    doughnut3d: fadeout.pie,
    heatmap: fadeout.heatmap,
    boxandwhisker2d: fadeout.boxandwhisker2d,
    multiaxisline: fadeout.line,
    default: fadeout['default']
  });
}

export default {
  extension: FCPlugger,
  name: 'PlotHighlighter',
  type: 'extension',
  requiresFusionCharts: !0
};